module.exports = global["React"] = require("-!/builds/lobaro/iot-dashboard/node_modules/react/dist/react.min.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?React!./~/react/dist/react.min.js
 ** module id = 17
 ** module chunks = 0 4
 **/